import React from 'react';
import {
  Dialog,
  DialogOverlay,
  DialogContent,
  DialogFooter,
  DialogClose,
  Button,
} from '@/app/shared/components';

interface Props {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const EndSeasonPopup: React.FC<Props> = ({ isOpen, onClose }) => {
  const title = process.env.VITE_END_SEASON_TITLE || 'Season ended';
  const message =
    process.env.VITE_END_SEASON_MESSAGE ||
    "The last season has ended. You can keep using the app, but your progress won’t count until the next one starts.";
  
  return (  
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogOverlay className="bg-customer-950/90" />
      <DialogContent className="max-w-md p-6">
        <div className="flex flex-col items-center gap-4">
          <h3 className="text-xl font-bold">{title}</h3>

          <p className="text-sm text-center">{message}</p>
        </div>

        <DialogFooter className="mt-4">
          <DialogClose asChild>
            <Button
              type="button"
              variant="primary"
              onClick={() => onClose(false)}
              className="w-full"
            >
              OK
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EndSeasonPopup;
